import { privateInstance } from "../configs";
import { mappers } from "@/mappers";

export const scheduledPreparationApi = {
  async getScheduledPreparations() {
    const res = await privateInstance.get(
      "/inventory/api/scheduledpreparation/"
    );
    return res.data.map(x => mappers.mapScheduledPrep(x));
  },
  async postScheduledPreparation(data) {
    const res = await privateInstance.post(
      "/inventory/api/scheduledpreparation/",
      data
    );
    return mappers.mapScheduledPrep(res.data);
  },
  async patchScheduledPreparation(data) {
    const res = await privateInstance.patch(
      `/inventory/api/scheduledpreparation/${data.id}/`,
      data
    );
    return mappers.mapScheduledPrep(res.data);
  },
  async deleteScheduledPreparation(id) {
    const res = await privateInstance.delete(
      `/inventory/api/scheduledpreparation/${id}/`
    );
    return mappers.mapScheduledPrep(res.data);
  }
};
